'use client'
import React from 'react'
import CTHeaderContainer from '../variants/cleartrip'
import FlyinHeaderContainer from '../variants/flyin'

interface HeaderContainerProps {
    hideSignIn?: boolean
    domainCountry?: string
    showVisa?: boolean
}

const HeaderContainer: React.FC<HeaderContainerProps> = ({ hideSignIn = false, domainCountry, showVisa = false }) => {
    const showFlyinHeader = domainCountry === 'FEG' || domainCountry === 'FSA' || domainCountry === 'FAE'

    return showFlyinHeader ? (
        <FlyinHeaderContainer hideSignIn={hideSignIn} showVisa={showVisa} />
    ) : (
        <CTHeaderContainer hideSignIn={hideSignIn} showVisa={showVisa} />
    )
}

export { HeaderContainer }
export default HeaderContainer
